<template>
<a
    :href="link"
    target="_blank"
    :class="$style.link_download"
    @click="$nc($event, 'fot.down')">
    <span :class="$style.pc">
        <span :class="$style.text">
            <em>{{ $t("links.whale") }}</em>
            <span>
                {{ $t("links.download") }}
                <svg-icon name="ic_go" />
            </span>
        </span>
        <img src="@/assets/img/icon_whale_2x.png">
    </span>
    <span :class="$style.mo">
        <svg-icon name="ic_whale" />
        {{ $t("links.whale_download_mo") }}
    </span>
</a>
</template>

<script>
import SvgIcon from "@/components/SvgIcon.vue";
import { getWhaleDownload } from "@/data/links.js";

export default {
    components: { SvgIcon },
    computed: {
        link() {
            return getWhaleDownload(this.$i18n.locale);
        }
    }
};
</script>

<style lang="scss" module>
@use "@/assets/scss/variables" as v;
@use "@/assets/scss/mixins" as m;
@use "@material/typography/typography";

.link_download {
    color: #9b9b9b;
    font-size: typography.px-to-rem(12px);
    display: flex;
    em {
        display: block;
        font-size: typography.px-to-rem(13px);
        color: #393939;
    }
    .mo {
        display: none;
    }
    .pc {
        display: flex;
        align-items: center;
        .text {
            display: flex;
            flex-direction: column;
            justify-content: center;
            span {
                margin-top: 3px;
            }
        }
        img {
            height: 37px;
            width: 37px;
            margin-left: 14px;
        }
        svg {
            width: 9px;
            height: 8px;
        }
    }
    @include m.lg {
        display: inline-block;
        width: 125px;
        height: 46px;
        border-radius: 3px;
        background-color: v.$whale-green;
        color: #fff;
        font-size: typography.px-to-rem(15px);
        text-align: center;
        line-height: 46px;
        &:hover {
            background-color: #04af95;
        }
        &:active {
            background-color: #07a48c;
        }
        .pc {
            display: none;
        }
        .mo {
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 3px;
            svg {
                width: 20px;
                height: 20px;
                margin-right: 7px;
                vertical-align: middle;
            }
        }
    }
    @include m.md {
        margin: 0 auto;
    }
}
</style>
